/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-10-30 19:04:06
 * @LastEditors: lkz
 * @LastEditTime: 2019-11-19 16:35:02
*/
export default [
  {
    path: '/taskManagement/myTask',
    name: '/myTask',
    meta: {
      title: '我的任务'
    },
    component: () => import(/* webpackChunkName: "example-taskManagement-myTask" */ '../views/taskManagement/myTask/myTask.vue')
  }, 
  {
    path: '/taskManagement/allTask',
    name: '/allTask',
    meta: {
      title: '全部任务'
    },
    component: () => import(/* webpackChunkName: "example-taskManagement-myTask" */ '../views/taskManagement/allTask/AllTask.vue')
  }, 
  {
    path: '/taskManagement/classifyManagement',
    name: '/classifyManagement',
    meta: {
      title: '任务类型管理'
    },
    component:
      () => import(/* webpackChunkName: "example-taskManagement-myTask" */ '../views/taskManagement/classifyManagement/ClassifyManagement.vue')
  },
  {
    path: '/taskManagement/taskDetailPage',
    name: '/taskDetail',
    meta: {
      title: '工作台'
    },
    component:
      () => import(/* webpackChunkName: "example-taskManagement-myTask" */ '../views/taskManagement/taskDetailPage/index.vue')
  }
]
